import type { AppRegistryPage } from '@plato/app-meta/ai-meta';
import { useCustomerListAiMeta } from '@plato/feature-customer-list/hooks/use-customer-list-ai-meta';
import { useMemo } from 'react';
import { useActivitiesAiMeta } from './pages/activities/index.tsx';
import { useCustomerDetailAiMeta } from './pages/customers/[customer_id]/index.tsx';
import { useCustomerInfoAiMeta } from './pages/customers/[customer_id]/info.tsx';
import { useCustomerInsightsAiMeta } from './pages/customers/[customer_id]/insights.tsx';
import { useDraftHeaderAiMeta } from './pages/drafts/[draft_id]/header.tsx';
import { useDraftLineItemsAiMeta } from './pages/drafts/[draft_id]/line-items.tsx';
import { useDraftListAiMeta } from './pages/drafts/index.tsx';
import { useEventsAiMeta } from './pages/events/index.tsx';
import { useExplorerAiMeta } from './pages/explorer.tsx';
import { useHomeAiMeta } from './pages/home/index.tsx';
import { useProductDetailAiMeta } from './pages/inventory/[product-id].tsx';
import { useOrderDetailAiMeta } from './pages/orders/[order_id]/index.tsx';
import { useOrderListAiMeta } from './pages/orders/index.tsx';
import { useQuoteDetailAiMeta } from './pages/quotes/[quote_id]/index.tsx';
import { useQuoteListAiMeta } from './pages/quotes/index.tsx';
import { useTasksAiMeta } from './pages/tasks/index.tsx';
import { useTeamAiMeta } from './pages/team.tsx';

export function useAppRegistry(): readonly AppRegistryPage[] {
    const activitiesPage = useActivitiesAiMeta();
    const customerListPage = useCustomerListAiMeta();
    const customerDetailPage = useCustomerDetailAiMeta();
    const customerInfoPage = useCustomerInfoAiMeta();
    const customerInsightsPage = useCustomerInsightsAiMeta();
    const draftListPage = useDraftListAiMeta();
    const draftHeaderPage = useDraftHeaderAiMeta();
    const draftLineItemsPage = useDraftLineItemsAiMeta();
    const eventsPage = useEventsAiMeta();
    const explorerPage = useExplorerAiMeta();
    const homePage = useHomeAiMeta();
    const productDetailPage = useProductDetailAiMeta();
    const orderListPage = useOrderListAiMeta();
    const orderDetailPage = useOrderDetailAiMeta();
    const quoteListPage = useQuoteListAiMeta();
    const quoteDetailPage = useQuoteDetailAiMeta();
    const tasksPage = useTasksAiMeta();
    const teamPage = useTeamAiMeta();

    return useMemo(
        () => [
            activitiesPage,
            customerListPage,
            customerDetailPage,
            customerInfoPage,
            customerInsightsPage,
            draftListPage,
            draftHeaderPage,
            draftLineItemsPage,
            eventsPage,
            explorerPage,
            homePage,
            productDetailPage,
            orderListPage,
            orderDetailPage,
            quoteListPage,
            quoteDetailPage,
            tasksPage,
            teamPage,
        ],
        [
            activitiesPage,
            customerListPage,
            customerDetailPage,
            customerInfoPage,
            customerInsightsPage,
            draftListPage,
            draftHeaderPage,
            draftLineItemsPage,
            eventsPage,
            explorerPage,
            homePage,
            productDetailPage,
            orderListPage,
            orderDetailPage,
            quoteListPage,
            quoteDetailPage,
            tasksPage,
            teamPage,
        ],
    );
}
